module.exports = __webpack_public_path__ + "static/media/schemes.f5929674.svg";